import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';

export type PrimaryButtonProps = ButtonProps & {
}

export function PrimaryButton (props: PrimaryButtonProps) {
    return <Button variant="contained" color="primary" {...props} />
}